import React from 'react';
import "../../../center admin css/centerAdmin.css"

type StatCardProps = {
	value: number | string;
	label: string;
	icon?: React.ReactNode;
};

const StatCard: React.FC<StatCardProps> = ({ value, label, icon }) => {
	return (
		<div className="stat-card">
			<div className="stat-card__header">
				<div className="stat-card__value">{value}</div>
				{icon && <div className="stat-card__icon">{icon}</div>}
			</div>
			<div className="stat-card__label">{label}</div>
		</div>
	);
};

export default StatCard;


